// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./~/extract-text-webpack-plugin/loader.js?{"remove":true}!./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/UiMenu.vue
 ** module id = 14
 ** module chunks = 0
 **/